import React from "react";
import { isEmpty } from "lodash";
import { Commafy } from "@sonder/ui/source/styled/fragments/Commafy";
import { Invisible } from "@sonder/ui/source/styled/fragments/Invisible";
import {
  Cell,
  useTableContext,
} from "@sonder/ui/source/styled/fragments/Table";
import {
  UserData,
  DispatchRolesData as UserDispatchRolesData,
} from "core/queries/GetTeam";
import { RemoveMemberButton } from "team/components/RemoveMemberButton";
import { UserSquadPicker } from "team/components/UserSquadPicker";

interface UserRowProps extends UserData {
  lastRow?: boolean;
}

export const UserRow = ({
  dispatchRoles,
  id: userId,
  email,
  name,
  tags,
}: UserRowProps) => {
  const { hovered } = useTableContext();

  const renderExistingRole = (role: UserDispatchRolesData) => {
    const { displayName, toolTip } = role;
    return (
      <span key={displayName} title={toolTip}>
        {displayName}
      </span>
    );
  };

  return (
    <>
      <Cell rowStart rowKey={userId}>
        {name}
      </Cell>
      <Cell rowKey={userId}>
        <i>{email}</i>
      </Cell>
      <Cell rowKey={userId}>
        <Invisible hidden={hovered !== userId && isEmpty(tags)}>
          <UserSquadPicker tags={tags} userId={userId} />
        </Invisible>
      </Cell>
      <Cell rowKey={userId}>
        <Commafy>{(dispatchRoles || []).map(renderExistingRole)}</Commafy>
      </Cell>
      <Cell rowEnd rowKey={userId}>
        <Invisible hidden={hovered !== userId}>
          <RemoveMemberButton userId={userId} />
        </Invisible>
      </Cell>
    </>
  );
};
